<template>
  <main>
    <!-- Hero section -->
    <div
      class="relative bg-cover bg-center"
      :style="{
        backgroundImage: `url(${require('../assets/images/podcast-mic.jpg')})`,
      }"
    >
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>
      <div
        class="relative md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto z-10 h-[30vh] lg:h-[60vh] flex items-center justify-start text-white"
      >
        <!-- Resource Section -->
        <h1
          class="text-4xl md:text-6xl px-4 lg:px-1 font-bold animate__animated animate__backInLeft"
        >
          Resources
        </h1>
      </div>

      <!-- Sleek Arch SVG Curve -->
      <svg
        class="absolute bottom-0 left-0 w-full"
        viewBox="0 0 1440 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#ffffff"
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
        />
      </svg>
    </div>

    <!-- Article section -->
    <div class="bg-white">
      <div class="md:px-12 max-w-screen-2xl mx-auto py-4 mt-6 mb-6">
        <h1 class="text-start text-4xl font-extrabold mt-6 px-4 lg:px-1">
          Articles
        </h1>
        <p class="text-start text-2xl mt-4 px-4 lg:px-1">
          Discover the perfect article to be an investor.
        </p>
      </div>

      <!-- Articles are coming soon -->
      <div class="md:px-12 max-w-screen-2xl mx-auto py-4 bg-[#f5f9ff]">
        <div
          class="flex flex-col lg:flex-row items-center rounded-lg gap-8"
        >
          <!-- Book Image -->
          <div class="flex-shrink-0">
            <img
              src="../assets/images/article.jpeg"
              alt="Unlock Book"
              class="w-64 lg:w-80 rounded-lg shadow-md"
            />
          </div>

          <!-- Content Section -->
          <div class="text-center lg:text-left">
            <!-- Book Tag -->
            <div
              class="inline-block bg-[#c3e7f7] text-[#1e4d72] px-4 py-1 rounded-full text-sm font-semibold mb-2"
            >
              📘 Articles
            </div>

            <!-- Heading -->
            <h2 class="text-3xl font-bold text-gray-800 mb-4">
              UNLOCK Great Investment
            </h2>

            <!-- Description -->
            <p class="text-gray-700 max-w-xl mb-6">
              In <strong>UNLOCK: The Secrets to a Winning Life</strong>, BUM
              presents a guide to personal transformation complete with journal,
              exercises, worksheets for individuals who want to create a Winning
              Life.
            </p>

            <!-- CTA Button -->
            <button
              class="bg-gradient rounded-lg text-white px-6 py-2 transition"
            >
              ➔ Coming soon
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Videos section -->
    <div class="bg-white">
      <featuredVideos />
    </div>

    <newsletterDownload />

    <!--  -->
    <div class="bg-main">
      <div class="md:px-12 max-w-screen-2xl mx-auto">
        <div class="flex flex-col lg:flex-row gap-10 items-center px-4 lg:px-1">
          <div class="lg:w-1/2 mt-14 mb-8">
            <p class="text-2xl mt-5 text-white">
              Ready to transform yourself or your organization to unlock new
              possibilities and create opportunities for success?
            </p>
            <!-- CTA Button -->
            <div class="flex items-center justify-start">
              <router-link
                to="/mshel-club"
                class="bg-blue rounded-lg text-white px-6 py-2 transition mt-6"
              >
                ➔ Join Mshel Club
              </router-link>
            </div>
          </div>
  
          <div class="lg:w-1/2 mt-14 mb-8">
            <img
              src="../assets/images/about-barka.jpeg"
              alt="About Barka U. Mshelia"
              class="w-full h-1/4 object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import newsletterDownload from "../components/newletterDownload.vue";
import featuredVideos from "../components/featuredVideos.vue";

export default {
  components: {
    newsletterDownload,
    featuredVideos,
  },
};
</script>

<style scoped>
svg path {
  fill: #fff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}
</style>
